import { Button, Modal } from "@scuf/common";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReplaceVm } from "../../../academy/view-course-templates/store/view-course-template.service";
import { customToast } from "../../../../../App";
import { RadioButton } from "@forge/common";
import { getVmListBySiteRequest } from "../../../academy/view-course-templates/store/view-course-template.action";

export const ReplaceModel = (props: any) => {
  const dispatch = useDispatch();
  const [selectedVM, setSelectedVM] = useState<any>("");
  const normalizeVmId = (id: string = "") => id.replace(/^vm-/i, "");
  const clickedVmId = normalizeVmId(props.clickedVmId ?? "");
  const vmList = useSelector(
    (state: any) => state?.viewCourseTemplateReducer?.vmListBySite ?? [],
  );

  useEffect(() => {
    dispatch(
      getVmListBySiteRequest({
        siteId: props.siteId,
        accessToken: props.accessToken,
      }),
    );
  }, [dispatch, props.siteId, props.accessToken]);

  useEffect(() => {
    const list = vmList || [];
    const defaultVm = list.find((vm: any) => vm.vmName === props.clickedVmName);
    setSelectedVM(defaultVm?.vmId || "");
  }, [vmList, props.clickedVmName]);

  const templateName = props.templateName;

  const handleReplace = async () => {
    if (!selectedVM || !clickedVmId) return;

    try {
      const res = await ReplaceVm({
        siteId: props.siteId,
        vmIdToAdd: selectedVM,
        vmIdToDelete: clickedVmId,
      });

      if (res?.message === "Replace Vm Initiated") {
        props.closeModel(false);
        customToast(
          `Initiated VM replacement for ${props.clickedVmName}`,
          "information",
        );
      }
    } catch (error) {
      console.error("ReplaceVm failed:", error);
    }
  };

  return (
    <Modal
      size="large"
      closeIcon={true}
      className="confirmAction"
      onClose={() => {
        props.closeModel(false);
      }}
      open={props.open}
      data-testid="plant-detail-confirm-modal"
      closeOnDimmerClick={false}
    >
      <Modal.Header>{"Replace VM"}</Modal.Header>
      <Modal.Content className="contentAction">
        <div className="mb-4">
          <label className="text-sm font-medium">List of VM's *</label>
        </div>
        <div className="mb-4 text-xs rounded-sm pb-3 pr-3">
          User can only replace one VM at a time. Please confirm that the
          selected VM can be replaced
        </div>
        <div className="mb-4">
          {vmList.length === 0 ? (
            <div>No VMs available</div>
          ) : (
            vmList.map((vm: any, index: number) => {
              const isDisabled = selectedVM !== "" && selectedVM !== vm.vmId;
              return (
                <div
                  key={index}
                  className={`vmlist flex items-center mb-3 ${isDisabled ? "opacity-50 pointer-events-none" : ""}`}
                >
                  <RadioButton
                    id={vm.vmId}
                    name="vmSelection"
                    data-testid={`replace-vm-${vm.vmId}`}
                    value={vm.vmId}
                    disabled={isDisabled}
                    checked={selectedVM === vm.vmId}
                    onChange={(e) => setSelectedVM(e.target.value)}
                    className="cursor-pointer mr-3"
                  >
                    <label
                      htmlFor={vm.vmId}
                      className={`text-xs m-0 ${isDisabled ? "" : "cursor-pointer"}`}
                    >
                      {vm.vmName}
                    </label>
                  </RadioButton>
                </div>
              );
            })
          )}
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button
          className="cancel-secondary"
          type="secondary"
          size="small"
          content="Cancel"
          data-testid="plant-detail-replace-no"
          onClick={() => {
            props.closeModel(false);
          }}
        />

        <Button
          className="save-secondary"
          type="primary"
          size="small"
          content={"Replace"}
          data-testid="plant-detail-replace-yes"
          onClick={() => {
            handleReplace();
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};
